import React, { useState } from 'react';
import { useInView } from '../hooks/useInView';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const faqs = [{
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente dopo il pagamento riceverai una email con il link per scaricare tutti gli 11 file (6 Volumi + 5 Bonus) sul tuo dispositivo. Puoi consultarli dal telefono, tablet o computer.'
  }, {
    q: 'È un abbonamento?',
    a: 'No. Paghi una sola volta €67 e hai accesso a vita a tutto il materiale. Nessun costo ricorrente, nessun rinnovo automatico.'
  }, {
    q: 'È adatto ai principianti?',
    a: 'Sì! I manuali sono progettati sia per istruttori esperti che per chi ha appena completato la formazione. Ogni protocollo include varianti di difficoltà e note di sicurezza.'
  }];
  return <section className="bg-white py-12 md:py-20 px-4" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <div ref={ref} className={`fade-in ${isVisible ? 'is-visible' : ''}`} data-id="element-26">
          <h2 className="font-heading text-xl md:text-3xl text-headline font-extrabold text-center mb-8 md:mb-12 tracking-tight" data-id="element-27">
            Domande Frequenti
          </h2>

          <div className="space-y-3" data-id="element-28">
            {faqs.map((faq, idx) => <div key={idx} className={`border rounded-brand overflow-hidden transition-all duration-300 ${openIdx === idx ? 'border-cta/30 shadow-soft' : 'border-gray-200'}`} data-id="element-29">
                <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-5 py-4 text-left flex justify-between items-center bg-white" data-id="element-30">
                  <span className="font-heading font-bold text-headline pr-4 text-sm md:text-base" data-id="element-31">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-cta transition-transform duration-300 flex-shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} strokeWidth={1.5} data-id="element-32" />
                </button>
                <div className={`px-5 overflow-hidden transition-all duration-300 ${openIdx === idx ? 'max-h-96 pb-4' : 'max-h-0'}`} data-id="element-33">
                  <p className="text-body text-sm font-light leading-relaxed" data-id="element-34">
                    {faq.a}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}